module.exports = __webpack_public_path__ + "media/images/icons/icon_poin_ap-775a6f135cf277cc572d27137e6500f7.svg";